"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Span = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const Box_1 = tslib_1.__importDefault(require("@mui/material/Box"));
const react_1 = require("react");
exports.Span = (0, react_1.forwardRef)((props, ref) => ((0, jsx_runtime_1.jsx)(Box_1.default, { component: "span", ...props, ref: ref })));
exports.Span.displayName = "Span";
//# sourceMappingURL=Span.js.map